import { useAppSelector, useMyApp, useTranslate } from '@common/hooks'
import ModalWrapper from '@common/modals/ModalWrapper'
import prepareAppDate from '@common/utils/prepareAppDate'
import Button from '@common/widgets/Button'
import type { IAppReview } from '@redux/slices/applicationRating/applicationRating.types'
import cx from 'classnames'
import React, { useState } from 'react'

import ModalReply from './ModalReply'
import classNames from './styles.module.scss'


function withReplySection<T extends IAppReview>(WrappedComponent: React.ComponentType<T>) {
  return (props: T): JSX.Element => {
    const currentUserId = useAppSelector(store => store.common.data.config?.token.user_id)
    const application = useAppSelector(store => store.application?.data) as IApplication

    const { translate } = useTranslate()
    const [showModal, setShowModal] = useState(false)
    const { isAppAuthor } = useMyApp(application)
    return (
      <>
        <WrappedComponent {...props} className={(props.developerResponse && !(currentUserId && currentUserId === props.userId)) ? classNames.reviewWithReply : ''}>
          {!props.developerResponse && isAppAuthor && (
            <Button
              className={classNames.replyButton}
              variant="icon"
              width="auto"
              onClick={() => setShowModal(true)}
              data-test="reply-create-btn"
            >
              <i className={cx(classNames.icon, classNames.replyIcon)} />
              {translate('Reply')}
            </Button>
          )}
        </WrappedComponent>
        {props.developerResponse && (props.developerResponseVisible || isAppAuthor) && (
            <div className={classNames.replyWrapper}>
              <blockquote className={classNames.replyBlock}>
                <h4 className={classNames.replyTitle} data-test="response-title">
                  {translate('App developer response')}
                  <div className={classNames.actionBar}>
                    {isAppAuthor && (
                      <Button
                        className={classNames.replyButton}
                        variant="icon"
                        width="auto"
                        onClick={() => setShowModal(true)}
                        data-test="edit-repl-btn"
                      >
                        <i className={cx(classNames.icon, classNames.editIcon)} />
                        {translate('Edit')}
                      </Button>
                    )}
                    <span data-test="review-response-date" className={classNames.date}>{prepareAppDate(props.developerResponseEdited || props.developerResponseCreated)}</span>
                  </div>
                </h4>
                <p className={classNames.replyText} data-test="developer-response">
                  {props.developerResponse}
                </p>
              </blockquote>
            </div>
        )}
        <ModalWrapper
          component={ModalReply}
          show={showModal}
          size="lg"
          review={props as unknown as IAppReview}
          onHide={() => setShowModal(false)}
          initialValues={props.developerResponse ? { body: props.developerResponse } : undefined}
          editMode={Boolean(props.developerResponse)}
        />
      </>
    )
  }
}

export default withReplySection
